export const alertService = window.alertServiceModule.alertService;